import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ArrowRightThin",
  "use": "svg-icon-ArrowRightThin-usage",
  "viewBox": "0 0 10 26",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 10 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-ArrowRightThin\"><path d=\"M.455 25l8-12-8-12\" stroke=\"#e3e4e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol